import { render, staticRenderFns } from "./ListSubjects.vue?vue&type=template&id=46a3de21&"
import script from "./ListSubjects.vue?vue&type=script&lang=js&"
export * from "./ListSubjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a3de21')) {
      api.createRecord('46a3de21', component.options)
    } else {
      api.reload('46a3de21', component.options)
    }
    module.hot.accept("./ListSubjects.vue?vue&type=template&id=46a3de21&", function () {
      api.rerender('46a3de21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/lists/components/ListSubjects.vue"
export default component.exports